import React from 'react';
import classnames from 'classnames';
import styles from './ActionItem.module.css';

type ActionItemProps = {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
};

export const ActionItem = ({
  children,
  className,
  onClick,
}: ActionItemProps) => (
  <button
    type="button"
    className={classnames(styles.actionItem, className)}
    onClick={onClick}
  >
    {children}
  </button>
);
